import 'animate.css';

export default  defineNuxtPlugin((app) =>{
  // Kosong
})